import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { serviceAreas, ohioCounties } from "../mock";

const countySlug = (name) => name.toLowerCase().replace(/ /g, "-");

const ServiceAreas = () => {
  return (
    <section className="section bg-white">
      <div className="mx-auto max-w-7xl px-4 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="text-[#2E9E6A] font-semibold uppercase tracking-wide text-sm">Where We Serve</span>
          <h2 className="font-display font-bold text-3xl md:text-4xl text-[#0E2A33] mt-2">
            Serving families across all of Ohio
          </h2>
          <p className="text-slate-600 mt-4">
            Headquartered in Columbus, Ohio with statewide DODD referral coverage. As a DODD-certified
            provider, we coordinate with county boards of developmental disabilities in every Ohio county.
            Actual service availability depends on staffing, location, schedule, and individual support requirements.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            {serviceAreas.map((c) => (
              <span key={c} className="inline-flex items-center gap-2 rounded-full bg-[#EAF4F7] text-[#0E5A72] px-4 py-2 text-sm font-medium">
                <MapPin className="h-4 w-4 text-[#2E9E6A]" /> {c}
              </span>
            ))}
          </div>
        </div>
        <div className="rounded-2xl overflow-hidden shadow-lg border border-slate-100">
          <iframe
            title="Service area map"
            src="https://www.google.com/maps?q=6161+Busch+Blvd,+Columbus,+OH+43229&output=embed"
            className="w-full h-[380px] border-0"
            loading="lazy"
          />
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 mt-14">
        <div className="brand-gradient-soft rounded-2xl p-8 border border-slate-100">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-5">
            <h3 className="font-display font-bold text-xl text-[#0E2A33]">All 88 Ohio Counties</h3>
            <span className="text-sm text-[#23875A] font-semibold">Statewide DODD referral coverage</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {ohioCounties.map((c) => (
              <Link
                key={c}
                to={`/ohio/${countySlug(c)}/home-care`}
                data-testid={`county-link-${countySlug(c)}`}
                className="inline-flex items-center rounded-full bg-white border border-slate-200 text-slate-700 px-3 py-1.5 text-sm hover:border-[#2E9E6A] hover:text-[#0E5A72] transition-colors"
              >
                {c}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
